import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import CarouselHeader from '@/components/FullPageCarousel/CarouselHeader';
import PostStatus from './PostStatus';
import { Button } from '@/components/ui/button';

const TIMEOUT_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds

function Loader({
  isLoading,
  hideHeader = false,
}: {
  isLoading: boolean;
  hideHeader?: boolean;
}) {
  const [isTimedOut, setIsTimedOut] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setIsTimedOut(false);
      return () => {};
    }

    const timeoutId = setTimeout(() => {
      setIsTimedOut(true);
    }, TIMEOUT_DURATION);

    return () => clearTimeout(timeoutId);
  }, [isLoading]);

  return (
    <div className="min-h-[600px] flex items-center justify-center bg-background flex-col pb-[100px]">
      {!hideHeader && <CarouselHeader disabled={isLoading} />}
      <div className="flex-grow flex items-center justify-center w-full">
        <div className="w-full max-w-2xl space-y-8 p-3">
          <div className="flex justify-center items-center space-x-2">
            {!isTimedOut && <PostStatus isLoading={isLoading} />}

            {isTimedOut && (
              <div className="text-center space-y-6">
                <div className="space-y-4">
                  <h3 className="text-2xl font-medium font-primary">
                    Processing is taking longer than expected
                  </h3>
                  <p className="text-muted-foreground font-secondary">
                    The upload process is taking longer than usual. Please
                    refresh the page to try again.
                  </p>
                </div>

                <div className="flex justify-center">
                  <Button
                    onClick={() => window.location.reload()}
                    variant="secondary"
                    className="flex items-center gap-2"
                    size="lg"
                  >
                    <RefreshCw className="h-4 w-4" />
                    Refresh Page
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Loader;
